<template>
  <div class="main-content">
    <div class="detail-table">
      <div>
        <div>
          <div class="detail-item-title">Kind</div>
          <div class="detail-item">{{ schedule.type | typeName}}</div>
        </div>
        <div>
          <div class="detail-item-title">Date</div>
          <div class="detail-item">{{ schedule.date | date }}</div>
        </div>
        <div>
          <div class="detail-item-title">Campus</div>
          <div class="detail-item">{{ schedule.campus && schedule.campus.name }}</div>
        </div>
        <div>
          <template v-if="schedule.type === 'waiting'">
            <div class="detail-item-title">Period</div>
            <div class="detail-item">{{ schedule.period }}</div>
          </template>
          <template v-else>
            <div>
              <div class="detail-item-title">From To</div>
              <div class="detail-item">
                {{ schedule.from | time }} ～ {{ schedule.to | time }}
              </div>
            </div>
            <div>
              <div class="detail-item-title">Participant Time</div>
              <div class="detail-item">
                {{ schedule.participantTime }} min
              </div>
            </div>
          </template>
        </div>
        <div>
          <div class="detail-item-title">Memo</div>
          <div class="detail-item">{{ schedule.memo }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Moment } from 'moment'
import { Prop, Component, Vue } from 'vue-property-decorator'
import { Schedule, scheduleType, ScheduleTypes } from '@/store/schedules/types'

@Component({
  filters: {
    /**
     * スケジュールタイプの名前を返す
     * @param {scheduleType} type スケジュール種別
     * @returns {string} スケジュール種別名
     */
    typeName(type: scheduleType): string {
      return ScheduleTypes[type]
    },

    /**
     * Dateを日付に変換
     * @param {Moment|null} date Date型
     * @returns {string} YYYY/MM/DD、無効な場合は空文字
     */
    date(date: Moment|null): string {
      if (!date) {
        return ''
      }

      return date.format('YYYY/MM/DD')
    },

    /**
     * Dateを時分に変換
     * @param {Moment|null} date Date型
     * @returns {string} HH:mm、無効な場合は空文字
     */
    time(date: Moment|null): string {
      if (!date) {
        return ''
      }

      return date.format('HH:mm')
    },
  },
})
export default class SchedulesContentsForm extends Vue {
  @Prop({ required: true }) schedule!: Schedule
}
</script>

<style scoped>
.main-content {
  background: #fff;
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
}

table.detail-table {
  width:100%;
}

.detail-table .detail-item-title {
  font-weight: bold;
  text-align: left;
  margin:10px 0;
}

.detail-table .detail-item {
  height:20px;
  margin-bottom: 20px;
  margin-left: 10px;
  font-size: 16px;
}

</style>
